// extracted by mini-css-extract-plugin
module.exports = {"uploadCover":"oam-video_uploadCover__1ckIP"};